import { render } from "./PageOption.vue?vue&type=template&id=e1ca2ccc"
import script from "./PageOption.vue?vue&type=script&lang=js"
export * from "./PageOption.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__